/**
 * Classic F: firefly nests beside sealed vaults (docs/spec/03 §2). Drop a boulder on a firefly
 * and its blast breaks the vault's brick side; steel keeps every other way shut.
 */

import type { CaveDef } from '../types';

export const caveF: CaveDef = {
  id: 'F',
  name: 'EMBER NESTS',
  hint: 'The vaults are sealed. The fireflies are the key.',
  intermission: false,
  colors: [2, 15, 7],
  diamondValue: 15,
  extraValue: 30,
  fill: { base: '.', items: [['r', 10], ['d', 3]] },
  levels: [
    { seed: 1601, diamonds: 12, time: 150 },
    { seed: 1602, diamonds: 15, time: 140 },
    { seed: 1603, diamonds: 18, time: 130 },
    { seed: 1604, diamonds: 22, time: 120 },
    { seed: 1605, diamonds: 26, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W......wrw.......????????....wrw.......W',
    'W.P....wrw.......????????....wrw.......W',
    'W......wrw.......????????....wrw.......W',
    'W??....wrw.......????????....wrw.......W',
    'W??..............????????..............W',
    'W??..... wWWWWWW.????????..... wWWWWWW.W',
    'W??.f    wd.d.dW.????????.f    wdddddW.W',
    'W??. ... w.d.d.W..wrw..... ... w.....W.W',
    'W??. ... wd.d.dW..wrw..... ... wd.d.dW.W',
    'W??. ... w.ddd.W..wrw..... ... w.d.d.W.W',
    'W??. ... w..dddW..wrw..... ... w..dddW.W',
    'W??.     r  dddW..........     r  dddW.W',
    'W??......WWWWWWW... wWWWWWW....WWWWWWW.W',
    'W?????????????.f    w..d..W.???????????W',
    'W?????????????. ... w.ddd.W.???????????W',
    'W?????????????. ... wd.d.dW.???????????W',
    'W?????????????. ... wdddddW.???????????W',
    'W?????????????. ... w..dd.W.????????X??W',
    'W?????????????.     r  dddW.???????????W',
    'W?????????????......WWWWWWW.???????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
